import script from "./menulaen.vue?vue&type=script&setup=true&lang=js"
export * from "./menulaen.vue?vue&type=script&setup=true&lang=js"

import "./menulaen.vue?vue&type=style&index=0&id=02c5315a&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02c5315a"]])

export default __exports__